import PwaUpdateAction from '@/core/pwa/PwaUpdateAction'
import { useLocation } from 'react-router-dom'
import { useAppStore } from '@runtime/core/store/appStore'
import { useI18n } from '@runtime/core/i18n/i18n'
import CoachLauncherDock from '@/features/coach/CoachLauncherDock'
import { usePlayShare } from '@/features/sharing/usePlayShare'
import HomeToast from '@/routes/home/components/HomeToast'
import ContactIcon from '@/components/icons/ContactIcon'
import ShareIcon from '@/components/icons/ShareIcon'
import PlayUtilityIcon from './PlayUtilityIcon'
import PlayLanguageSelect from './PlayLanguageSelect'
import PlayPosterButton from './PlayPosterButton'
import { usePlayHeaderActions } from './usePlayHeaderActions'
import styles from './PlayHeaderActions.module.scss'

export default function PlayHeaderActions() {
  const { t } = useI18n()
  const authToken = useAppStore(state => state.authToken)
  const setLoginOpen = useAppStore(state => state.setLoginOpen)
  const showPoster = useLocation().pathname !== '/home'
  const { mobile, open, setOpen, menuRef, buttonRef, closeBeforeAction, restoreFocus } =
    usePlayHeaderActions()
  const { share, toast } = usePlayShare()
  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className={styles.menuButton}
        popoverTarget="play-header-actions"
        aria-label={t('common.playNavigation.openActions')}
        aria-expanded={mobile && open}
        aria-controls="play-header-actions"
        aria-haspopup="dialog"
        data-testid="play-actions-open"
      >
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
          <g fill="currentColor">
            <circle cx="5" cy="12" r="1.8" />
            <circle cx="12" cy="12" r="1.8" />
            <circle cx="19" cy="12" r="1.8" />
          </g>
        </svg>
      </button>
      <div
        ref={menuRef}
        id="play-header-actions"
        className={styles.actions}
        popover={mobile ? 'auto' : undefined}
        role={mobile ? 'dialog' : undefined}
        aria-label={mobile ? t('common.playNavigation.actionsLabel') : undefined}
        onToggle={event => setOpen(event.newState === 'open')}
        onClickCapture={event => {
          const action =
            event.target instanceof Element ? event.target.closest<HTMLElement>('button,a') : null
          if (action) closeBeforeAction(action)
        }}
        data-testid="play-header-actions"
      >
        <button
          type="button"
          className={styles.profileButton}
          data-testid="login-button"
          onClick={() => setLoginOpen(true)}
        >
          <PlayUtilityIcon kind="account" />
          <span>
            {t(authToken ? 'common.playNavigation.account' : 'common.playNavigation.signIn')}
          </span>
        </button>
        <label className={styles.languageControl} data-testid="play-language-control">
          <PlayUtilityIcon kind="language" />
          <span>{t('common.language')}</span>
          <PlayLanguageSelect />
        </label>
        <CoachLauncherDock compact menu={mobile} className={styles.coachDock} />
        {showPoster && <PlayPosterButton className={styles.posterButton} testId="play-poster" />}
        <div className={styles.links}>
          <PwaUpdateAction />
          <button
            type="button"
            data-testid="play-share"
            onClick={async () => {
              await share()
              restoreFocus()
            }}
          >
            <ShareIcon />
            <span>{t('common.share')}</span>
          </button>
          <a href="mailto:contact@united-square.com" data-testid="play-contact">
            <ContactIcon />
            <span>{t('home.contactTitle')}</span>
          </a>
        </div>
      </div>
      <HomeToast toast={toast} />
    </>
  )
}
